/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup'
import i18n from '../../../i18n'
import { VALIDATION } from '../../../utils/translation-constants'

export const DeLinkAccountSchema = Yup.object().shape({
  accountNo: Yup.string()
    .required(i18n.t(VALIDATION.ACCOUNTNO)),
})
